module.exports = __webpack_public_path__ + "img/11-uupunut-sydan.6e8e3675.jpg";